import React from 'react'
import clsx from 'clsx'
import {ListPosCourses} from '../components/ListPosCourses'
import {ImgFilters} from '../components/ImgFilters'
import {Typography} from '../components/Typography'
import {Tag} from '../components/Tag'
import {Icon} from '../components/Button'
import {usePosCoursesQuery} from '../utils/hooks/usePosCoursesQuery'
import cursosPosImg from '../img/cursos-pos.png'
import waveRight from '../img/icons/wave-right.svg'
import icon100Online from '../img/icons/feo_100online.svg'
import iconCertificado from '../img/icons/feo_certificado.svg'
import iconFiltro from '../img/icons/feo_filtro.svg'
import iconInteracoesGravadas from '../img/icons/feo_interacoesgravadas.svg'
import iconProfessores from '../img/icons/feo_professores.svg'

import polygonBlue from '../img/polygon-blue.png'

const Hero = ({imgDesktop, imgMobile, tag, title}) => {
  return (
    <div className="relative w-full h-98">
      <ImgFilters img={imgMobile} transparency paralax className="lg:hidden" />
      <ImgFilters
        img={imgDesktop}
        transparency
        paralax
        className="hidden lg:block"
      />
      <div className="absolute inset-0 px-10 lg:px-36">
        <div className="grid gap-2.5 grid-cols-4 grid-flow-col mt-28 lg:grid-cols-12 lg:gap-4">
          <div className="col-start-1 col-end-5 lg:col-start-1 lg:col-end-8">
            <Tag>{tag}</Tag>
          </div>
          <div className="col-start-1 col-end-5 lg:col-start-1 lg:col-end-13">
            <Typography
              variant="heading-xl"
              uppercase
              className="text-white lg:text-4xl text-shadow"
            >
              {title}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

const LearningOnline = ({phrase1, phrase2}) => {
  return (
    <div className="relative my-12 lg:min-h-600">
      <Typography size="lg" align="center">
        {phrase1}
      </Typography>
      <Typography
        uppercase
        color="blue-500"
        size="lg"
        weight="black"
        align="center"
      >
        {phrase2}
      </Typography>
      <div className="flex items-center justify-center">
        <img src={cursosPosImg} />
      </div>

      <div
        className="absolute left-0 bg-right bg-no-repeat -z-10 top-1/2 lg:-left-12 h-39 w-96 transform -translate-y-1/4 lg:-translate-y-1/2 rotate-180"
        style={{backgroundImage: `url(${waveRight})`}}
      ></div>
      <div
        className="absolute right-0 bg-right bg-no-repeat -z-10 top-1/2 lg:-right-12 h-39 w-96 transform -translate-y-3/4 lg:-translate-y-1/2"
        style={{backgroundImage: `url(${waveRight})`}}
      ></div>
    </div>
  )
}

const TypeBlue = ({children}) => (
  <Typography as="strong" weight="black" uppercase color="blue-500">
    {children}
  </Typography>
)

const Type = ({children}) => (
  <Typography as="span" uppercase>
    {children}
  </Typography>
)

const PosInFisio = () => {
  return (
    <section className="px-4 lg:px-32">
      <div className="relative bg-white z-2 lg:shadow-md lg:rounded-md">
        <div
          className="shadow-md lg:rounded-md absolute -top-3 w-screen -left-10 lg:w-full lg:left-3 h-2.5 lg:h-12 bg-blue-100"
          style={{zIndex: '-1'}}
        ></div>
        <div
          className="shadow-md lg:rounded-md absolute w-screen -left-10 lg:w-full lg:-left-3 -bottom-3 h-2.5 lg:h-12 bg-blue-100"
          style={{zIndex: '-1'}}
        ></div>
        <div
          className="absolute -bottom-7 left-1/2 transform -translate-x-8"
          style={{width: '64px', height: '17px', zIndex: '-1'}}
        >
          <img src={polygonBlue} alt="" />
        </div>
        <div className="flex items-center justify-between pt-3 pb-5">
          <div className="w-6 h-1 bg-gray-100 lg:w-full"></div>
          <h3 className="px-2 text-center lg:whitespace-nowrap">
            <Typography
              as="p"
              variant="heading2"
              align="center"
              color="blue-500"
            >
              <Typography as="span" variant="heading2" uppercase weight="black">
                pós-graduação na fisio
              </Typography>
              <Typography as="span" variant="heading2" weight="black">
                em
              </Typography>
              <Typography as="span" variant="heading2" uppercase weight="black">
                ortopedia
              </Typography>
            </Typography>
          </h3>
          <div className="w-6 h-1 bg-gray-100 lg:w-full"></div>
        </div>
        <div className="relative text-center pb-5 grid items-center gap-2.5 grid-cols-4 grid-flow-col lg:grid-cols-12 lg:gap-4">
          <div className="items-center col-start-1 col-end-5 lg:col-start-1 lg:col-end-1">
            <Icon icon={iconProfessores} />
          </div>
          <div className="items-center col-start-1 col-end-5 lg:col-start-2 lg:col-end-5">
            <Typography as="p" className="text-center lg:text-left">
              <TypeBlue>PROFESSORES RENOMADOS</TypeBlue> que são{' '}
              <TypeBlue>referência</TypeBlue> em suas áreas de atuação.
            </Typography>
          </div>

          <div className="items-center col-start-1 col-end-5 lg:col-start-5 lg:col-end-5">
            <Icon icon={iconFiltro} />
          </div>
          <div className="items-center col-start-1 col-end-5 lg:col-start-6 lg:col-end-9">
            <Typography as="p" className="text-center lg:text-left">
              Inovação em formas de <TypeBlue>INTERAÇÃO</TypeBlue> e{' '}
              <TypeBlue>APRENDIZADO INDIVIDUALIZADO</TypeBlue>.
            </Typography>
          </div>

          <div className="items-center col-start-1 col-end-5 lg:col-start-9 lg:col-end-9">
            <Icon icon={iconCertificado} />
          </div>
          <div className="items-center col-start-1 col-end-5 lg:col-start-10 lg:col-end-13">
            <Typography as="p" className="text-center lg:text-left">
              <TypeBlue>CERTIFICADO</TypeBlue> de Pós-Graduação reconhecido pelo{' '}
              <TypeBlue>MEC</TypeBlue>.
            </Typography>
          </div>

          <div className="items-center col-start-1 col-end-5 lg:col-start-3 lg:col-end-3">
            <Icon icon={iconInteracoesGravadas} />
          </div>
          <div className="items-center col-start-1 col-end-5 lg:col-start-4 lg:col-end-7">
            <Typography as="p" className="text-center lg:text-left">
              <TypeBlue>Aulas assíncronas</TypeBlue> e{' '}
              <TypeBlue>interaçōes online</TypeBlue> para poder assistir depois.
            </Typography>
          </div>

          <div className="items-center col-start-1 col-end-5 lg:col-start-7 lg:col-end-7">
            <Icon icon={icon100Online} />
          </div>
          <div className="items-center col-start-1 col-end-5 lg:col-start-8 lg:col-end-11">
            <Typography as="p" className="text-center lg:text-left">
              Curso de Pós-Graduação <TypeBlue>lato sensU 100% online</TypeBlue>
              .
            </Typography>
          </div>
        </div>
      </div>
    </section>
  )
}

const Page = ({heroBannerSingle, learningOnline, ...props}) => {
  const courses = usePosCoursesQuery()
  return (
    <div className={clsx('mx-auto')}>
      <Hero {...heroBannerSingle} />
      <LearningOnline {...learningOnline} />
      <PosInFisio />
      <div className="my-12">
        <ListPosCourses courses={courses} />
      </div>
    </div>
  )
}

const Template = ({pageContext}) => {
  return <Page {...pageContext?.frontmatter} />
}

export default Template
